<template>
    <div class="comments-component">
        <div class="title">
            {{translate('Comments')}}
        </div>
        <div class="grid">
            <label v-if="comments.placeTitle">
                <span v-if="showReportByChosen.tag == 'by_questions'">{{translate('Question')}}:</span>
                <span v-if="showReportByChosen.tag == 'by_sites'">{{translate('site')}}:</span>
                <span v-if="showReportByChosen.tag == 'by_locations'">{{translate('Location')}}:</span>
            </label>
            <span class="sub" v-if="comments.placeTitle"> {{comments.placeTitle}}</span>

            <label v-if="comments.siteName">
                <span>{{translate('site')}}:</span>
            </label>
            <span class="sub" v-if="comments.siteName"> {{comments.siteName}} </span>

            <label v-if="comments.question">
                <span>{{translate('Question')}}:</span>
            </label>
            <span v-if="comments.question">{{comments.question}}</span>

            <label v-if="comments.optional">
                <span>{{translate('Location')}}:</span>
            </label>
            <span v-if="comments.optional">{{comments.optional}}</span>
            <label v-if="comments.asset_id">
                <span>{{translate('own_AssetId')}}:</span>
            </label>
            <span v-if="comments.asset_id">{{comments.asset_id}}</span>
        </div>
        <div class="content">
            <div v-if="limitedAccess.show" class="limited_access"
                 v-html="translate('own_limitedAccessText', [limitedAccess.totalCount, `<a href='mailto:team@air-vote.com?subject=Limited access' style='color:#245bc4; text-decoration:underline;'>team@air-vote.com</a>`])"></div>
            <ul>
                <li
                    v-for="item in items"
                    :key="item.itemId"
                    :rate="item.rate">
                    <span class="date">{{item.date | moment("MMM D YYYY, h:mm a")}}</span>
                    <div><span :class="`answer value-${item.rate}`" v-if="shouldShowAnswer(item)">{{item.answer}}</span><span class="placement" v-if="showReportByChosen.tag !== 'by_locations' && !comments.optional && item.placement != ''">({{item.placement}})</span><span class="placement" v-if="!comments.asset_id && item.asset_id && item.asset_id != ''">({{item.asset_id}})</span></div>
                    <span class="map_link" v-if="shouldShowMapLink(item)"><a :href="getGeolocationGoogleMapLink(item)" target="_blank">{{translate('commentViewOnMap')}}</a></span>
                    <p>{{item.comment}}</p>
                    <p v-if="item.contact_info"><i>{{item.contact_info}}</i></p>
                    <p v-if="item.attachments.audio"><audio controls :src="item.attachments.audio.audio_url" class="vote-audio"></audio></p>
                    <p v-if="item.sec_level.length > 0"><i>{{item.sec_level.join(', ')}}</i></p>
                    <div class="attachments" v-if="item.attachments.images.length > 0">
                        <img v-for="(item, index) in item.attachments.images"
                             :key="index"
                             :src="item.previewUrl"
                             @click="onVoteImageClick(item)"/>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapState} from "vuex";
    import errorMixin from '@/mixins/errorMixin';
    import moment from "moment";


    export default {
        name: 'comments',

        data(){
            return {
                items: [],
                limitedAccess: {
                    show: false,
                    totalCount: 0,
                },
            }
        },

        mixins: [errorMixin],

        props: ['comments'],

        async mounted() {
            await this.fetchComments()
        },

        watch: {
            comments(){
                this.fetchComments()
            }
        },

        computed: {
            ...mapState({
                showReportByChosen: state => state.owner.showReportByChosen,
                analyticTimeFilter: state => state.owner.analyticTimeFilter,
                customDate: state => state.owner.customDate,
            })
        },

        methods: {

            ...mapActions({
                fetchCommentsActions: 'owner/fetchComments'
            }),

            async fetchComments(){
                try {
                    let body = {}
                    if (this.customDate.date_from && this.analyticTimeFilter.attr != 'all') {
                        body.date_from_local = moment(new Date(this.customDate.date_from)).format("YYYY-MM-DD HH:mm:ss")
                    }
                    if (this.customDate.date_to && this.analyticTimeFilter.attr != 'all') {
                        body.date_to_local = moment(new Date(this.customDate.date_to)).format("YYYY-MM-DD HH:mm:ss")

                    }
                    if (this.comments.placeUids) {
                        body.place_uids = this.comments.placeUids
                    }
                    if (this.comments.questionUids) {
                        body.question_uids = this.comments.questionUids
                    }
                    const response = await this.fetchCommentsActions({ body })
                    this.items = response.comments
                    if(response.limited_votes && response.limited_votes.total_count > 0) {
                        this.limitedAccess.show = true
                        this.limitedAccess.totalCount = response.limited_votes.total_count
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            onVoteImageClick(item) {
                window.open(item.originUrl, '_blank')
            },

            shouldShowAnswer(rate) {
                return rate.answer == null ? false : (rate.rate == 3 && this.translate('own_Happy').toUpperCase() !== rate.answer.toUpperCase()) || (rate.rate == 2 && this.translate('own_SoSo').toUpperCase() !== rate.answer.toUpperCase()) || (rate.rate == 1 && this.translate('own_Sad').toUpperCase() !== rate.answer.toUpperCase())
            },

            shouldShowMapLink(vote) {
                return vote.rate_location != null
            },

            getGeolocationGoogleMapLink(vote) {
                let loc = vote.rate_location
                if(loc == null) return ''
                return `https://www.google.com/maps/place/${loc.lat},${loc.lng}/@${loc.lat},${loc.lng},17z`
            },

        }
    }

</script>

<style scoped>

    .title {
        color: #2F2F2F;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 20px;
        font-weight: 500;
    }

    .grid {
        display: grid;
        grid-template-columns: max-content auto;
        align-content: center;
        color: #2F2F2F;
        grid-gap: 8px;
    }

    .grid * {
        display: flex;
        align-content: center;
    }

    .grid label {
        font-weight: 500;
        font-size: 14px;
        /*line-height: 22px;*/
        margin-right: 16px;
        margin-bottom: 0;
    }
    .grid .sub {
        font-weight: 300;
        font-size: 14px;
        /*line-height: 17px;*/
    }

    .content ul {
        margin-top: 15px;
        margin-bottom: 90px;
    }
    .content li {
        padding: 10px 16px;
        width: 100%;
        margin: 0 0 8px 0;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        background: #F7F7F7;
    }

    .content li:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
    }

    .content li[rate="3"]:before { background-color: #36BC00 }
    .content li[rate="2"]:before { background-color: #FEB000 }
    .content li[rate="1"]:before { background-color: #EF4200 }

    .content li .date {
        color: #6D6D6D;
        font-size: 13px;
        line-height: 18px;
        font-weight: 300;
        margin-bottom: 3px;
    }

    .content li p {
        margin: 0;
        font-size: 14px;
        color: #2F2F2F;
    }
    .content li .placement {
        color: #6D6D6D;
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        padding-bottom: 5px;
        padding-right: 10px;
        width: 100%;
        word-break: break-all;
    }
    .content li .map_link {
        color: #212121;
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        padding-bottom: 5px;
        padding-right: 10px;
        width: 100%;
        word-break: break-all;
    }
    .content li .map_link a {
        color: #535353;
        text-decoration: underline;
    }
    .content li .answer {
        color: #6D6D6D;
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        padding-bottom: 5px;
        padding-right: 10px;
        width: 100%;
        word-break: break-all;
    }
    .content li .answer.value-1 {
        color: #EF4200;
    }
    .content li .answer.value-2 {
        color: #FEB000;
    }
    .content li .answer.value-3 {
        color: #36BC00;
    }

    .attachments {
        margin-top: 4px;
        height: 50px;
        overflow: scroll;
        display: flex;
    }
    .attachments img {
        max-width: 100%;
        max-height: 50px;
        cursor: pointer;
        margin-right: 4px;
    }

    .vote-audio {
        margin-top: 8px;
        height: 40px;
        width: 100%;
        display: block;
    }
    .limited_access {
        white-space: pre-line;
        font-weight: 500;
        color: #a30000;
        margin-top: 16px;
    }
    .close {
        position: relative !important;
        top: -6px !important;
        cursor: pointer !important;
    }

</style>
